import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingAttributes(props) {

  const [attributes, setAttributes] = useState({
    itemName: "",
    brand: "",
    color: "",
    size: "",
    material: "",
    bullet1: "",
    bullet2: "",
    description: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setAttributes({
      ...attributes,
      [name]: value
    });
  };

  return (

    <Container>

      <Row>

        {/* Page Title */}
        <Col md={12} className="mt-4 mb-3">
          <h4>Step 4 : Product Attributes</h4>
        </Col>


        {/* Attributes Form */}
        <Col md={12}>

          <Card className="p-4">

            <Row className="mb-3">
              <Col md={4}><b>Item Name</b></Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="itemName"
                  value={attributes.itemName}
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Brand</b></Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="brand"
                  value={attributes.brand}
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Color</b></Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="color"
                  value={attributes.color}
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Size</b></Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="size"
                  value={attributes.size}
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Material</b></Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="material"
                  value={attributes.material}
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Bullet Point 1</b></Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="bullet1"
                  value={attributes.bullet1}
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Bullet Point 2</b></Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="bullet2"
                  value={attributes.bullet2}
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Description</b></Col>
              <Col md={8}>
                <Input
                  type="textarea"
                  rows="4"
                  name="description"
                  value={attributes.description}
                  onChange={handleChange}
                />
              </Col>
            </Row>

          </Card>

        </Col>


        {/* Navigation Buttons */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={props.nextStep}
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingAttributes;